import { ApiService } from "../api";
import { Project } from "./";

/**
 * Functions for fetching projects.
 */
export class ProjectService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	/**
	 * Return all projects the current user is a member of
	 */
	public async findMine(searchTerm?: string): Promise<Project[]> {
		const params = { completed: false, search: searchTerm };

		return this.getProjects("my-projects", params);
	}

	/**
	 * Return all projects for the current user that are not completed.
	 */
	public async findMineOpen(searchTerm?: string): Promise<Project[]> {
		const params = { completed: false, search: searchTerm };

		return this.getProjects("my-projects", params);
	}

	/**
	 * Return all projects for the current user that are completed.
	 */
	public async findMineCompleted(searchTerm?: string): Promise<Project[]> {
		const params = { completed: true, search: searchTerm };

		return this.getProjects("my-projects", params);
	}

	/**
	 * Find all projects for a given account.
	 *
	 * @param accountId
	 */
	public async findByAccount(accountId: string): Promise<Project[]> {
		return this.getProjects(accountId);
	}

	/**
	 * Toggle watching a project for the current user.
	 * @param project
	 */
	public async toggleWatching(project: Project): Promise<Project> {
		const projectData = await this.apiService.post(
			`/api/v1/project/${project.id}/toggle-watching`,
		);

		const projectJson = await projectData.json();

		return Project.fromJson(projectJson);
	}

	private async getProjects(
		endpoint: string,
		params?: object,
	): Promise<Project[]> {
		const projectData = await this.apiService.get(
			`/api/v1/projects/${endpoint}`,
			params,
		);
		const projects = await projectData.json();

		return Project.fromJsonArray(projects);
	}
}
